// https://vuex.vuejs.org/en/getters.html

export default {
  getActiveTab: (state) => {
    return state.activeTab
  },
  getRanking: (state) => {
    return state.ranking
  }
}
